// @ts-ignore

import { prefixPlugin } from "j2c-plugin-prefix-browser/dist/j2c-plugin-prefix-browser.commonjs";
import J2c from "j2c";

export const j2c = new J2c(prefixPlugin);
